import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  OnInit,
  Output,
  viewChild,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  ExpansionPanelModule,
  IconModule,
  PopoverDirective,
  SpinnerDirective,
} from '@hglobal/common';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { RootState } from '@pt/store';
import { TextFormaterHelper } from '@pt/helpers';

import { SupportActions, SupportSelectors, SupportViewModel } from './store';
import { ContactDialog } from './components/contact/contact.dialog';

@Component({
  selector: 'pu-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    ButtonModule,
    PopoverDirective,
    IconModule,
    RouterLink,
    ExpansionPanelModule,
    TranslateModule,
    RouterLinkActive,
    SpinnerDirective,
    NgTemplateOutlet,
  ],
  providers: [ContactDialog],
})
export class SupportComponent implements OnInit {
  routerLinkActiveDirective = viewChild(RouterLinkActive);
  type = input<'popover' | 'list'>('popover');

  @Output() clickItem = new EventEmitter<'faq' | 'contact_support'>();

  vm$: Observable<SupportViewModel> = this._store.select(SupportSelectors.selectViewModel);

  get isActive() {
    return this.routerLinkActiveDirective()?.isActive;
  }

  constructor(private _store: Store<RootState>, private _contactDialog: ContactDialog) {
  }

  ngOnInit(): void {
    this._store.dispatch(SupportActions.init({ routeData: {} }));
  }

  openTipsDialog(type: string): void {
    this.clickItem.emit();
    this._store.dispatch(SupportActions.getTipsReq.action({ payload: { type } }));
  }

  openContactDialog(): void {
    this.clickItem.emit('contact_support');
    this._contactDialog.open();
  }

  getCategorySlug(vm: SupportViewModel): string {
    const category = vm.categories.find(category => category.id === vm.categoryId);
    const categorySlug
      = category?.name ? `/${TextFormaterHelper.transformToSnakeCase(category?.name)}` : '';
    return categorySlug;
  }
}
